// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/bid_segment.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/bid_segment.proto.
 */
export const file_bfftypes_v1_bid_segment: GenFile = /*@__PURE__*/
  fileDesc("Ch1iZmZ0eXBlcy92MS9iaWRfc2VnbWVudC5wcm90bxILYmZmdHlwZXMudjEqfAoKQmlkU2VnbWVudBIbChdCSURfU0VHTUVOVF9VTlNQRUNJRklFRBAAEhsKF0JJRF9TRUdNRU5UX1NQT1RfTk9STUFMEAESGgoWQklEX1NFR01FTlRfU1BPVF9CTE9DSxACEhgKFEJJRF9TRUdNRU5UX0lOVFJBREFZEANCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * BidSegment classifies the bid market + bid type combination.
 * SPOT_NORMAL / INTRADAY have associated market_order_policy entries;
 * SPOT_BLOCK does not (block bidding is all-or-nothing and cannot be
 * market-priced).
 *
 * Hosted under bfftypes/v1 so future bidding / 入札画面の BFF service が
 * 同じ enum を共有できる (= ytnsym 指摘 #3259242489)。
 *
 * @generated from enum bfftypes.v1.BidSegment
 */
export enum BidSegment {
  /**
   * @generated from enum value: BID_SEGMENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BID_SEGMENT_SPOT_NORMAL = 1;
   */
  SPOT_NORMAL = 1,

  /**
   * @generated from enum value: BID_SEGMENT_SPOT_BLOCK = 2;
   */
  SPOT_BLOCK = 2,

  /**
   * @generated from enum value: BID_SEGMENT_INTRADAY = 3;
   */
  INTRADAY = 3,
}

/**
 * Describes the enum bfftypes.v1.BidSegment.
 */
export const BidSegmentSchema: GenEnum<BidSegment> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_bid_segment, 0);

